import { render, staticRenderFns } from "./NotPermission.vue?vue&type=template&id=1a930299&scoped=true&"
import script from "./NotPermission.vue?vue&type=script&lang=js&"
export * from "./NotPermission.vue?vue&type=script&lang=js&"
import style0 from "./NotPermission.vue?vue&type=style&index=0&id=1a930299&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a930299",
  null
  
)

export default component.exports